import View from 'ln/view/View';

import { QuizQuestion as template } from 'templates/components/quiz';
import { QuizQuestion } from './QuizQuestion';


export class QuizQuestionView extends View<QuizQuestion> {

    public constructor() {
        super({ template });
    }
}
